// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import Button from '../controls/PrimaryButton'
import postJson from '../../services/postJson'
import ErrorText from '../controls/ErrorText'

type Props = {|
  name: string,
  url: string,
  disabled: boolean,
  onAmountChange: Function
|}

type State = {|
  amount: string,
  isLoading: boolean,
  errors: Array<string>
|}

const t = {
  amount: 'Сумма',
  replenish: 'Пополнить',
  withdraw: 'Снять'
}

export default class AmountInput extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      amount: '',
      isLoading: props.disabled,
      errors: []
    }
  }

  render() {
    return (
      <div>
        <input
          id={`${this.props.name}_amount`}
          className="input-item input-item_small"
          type="text"
          name={`${this.props.name}_amount`}
          placeholder={t.amount}
          disabled={this.state.isLoading}
          value={this.state.amount}
          onChange={(e) => this.setState({ amount: e.target.value, errors: [] })}
        />
        <Button
          disabled={this.state.isLoading}
          height={35}
          onClick={() => {
            this.setState({ isLoading: true })
            postJson(this.props.url, { data: { amount: this.state.amount } })
              .done((response) => {
                const data = response.data
                this.setState({ amount: '' })
                if (!_.isEmpty(data.message)) window.alert(data.message)
                this.props.onAmountChange(data.balance, data.blocked_balance)
              })
              .fail((e: any) => {
                if (e.status === 422) {
                  this.setState({ errors: e.responseJSON.message })
                } else {
                  window.alert('Internal error')
                }
              })
              .always(() => this.setState({ isLoading: false }))
          }}
        >
          {t[this.props.name]}
        </Button>
        <ErrorText errors={this.state.errors} />
      </div>
    )
  }
}
